var _path, _rect, _rect2, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloads = function SvgDownloads(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 78,
    fill: "none",
    viewBox: "0 0 78 78"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    width: 61.188,
    height: 61.188,
    x: 16.406,
    y: 0.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#downloads_svg__a)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#downloads_svg__b)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#downloads_svg__c)",
    d: "M27 24.8c0-5.88 0-8.82 1.144-11.067a10.5 10.5 0 0 1 4.59-4.589C34.978 8 37.918 8 43.8 8h6.4c5.88 0 8.82 0 11.067 1.144a10.5 10.5 0 0 1 4.589 4.59C67 15.978 67 18.918 67 24.8v6.4c0 5.88 0 8.82-1.144 11.067a10.5 10.5 0 0 1-4.59 4.589C59.022 48 56.082 48 50.2 48h-6.4c-5.88 0-8.82 0-11.067-1.144a10.5 10.5 0 0 1-4.589-4.59C27 40.022 27 37.082 27 31.2z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.15,
    strokeWidth: 0.375,
    d: "M43.8 8.188h6.4c2.943 0 5.14 0 6.881.142 1.74.142 3.008.425 4.1.982a10.3 10.3 0 0 1 4.508 4.506c.556 1.093.839 2.362.98 4.1.143 1.742.144 3.939.144 6.882v6.4c0 2.943 0 5.14-.143 6.881-.142 1.74-.425 3.008-.981 4.1a10.3 10.3 0 0 1-4.507 4.508c-1.093.556-2.362.839-4.1.98-1.742.143-3.939.144-6.882.144h-6.4c-2.943 0-5.14 0-6.881-.143-1.74-.142-3.008-.425-4.1-.982a10.3 10.3 0 0 1-4.508-4.506c-.556-1.093-.839-2.362-.98-4.1-.143-1.742-.143-3.939-.143-6.882v-6.4c0-2.943 0-5.14.142-6.881.142-1.74.425-3.008.982-4.1a10.3 10.3 0 0 1 4.506-4.507c1.093-.557 2.362-.84 4.1-.982 1.742-.142 3.939-.143 6.882-.143Z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 61.188,
    height: 61.188,
    x: 8.406,
    y: 8.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#downloads_svg__d)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#downloads_svg__e)",
    shapeRendering: "crispEdges"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 19,
    y: 16,
    fill: "url(#downloads_svg__f)",
    fillOpacity: 0.5,
    rx: 10.5
  })), /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 19,
    y: 16,
    fill: "url(#downloads_svg__g)",
    fillOpacity: 0.25,
    rx: 10.5,
    style: {
      mixBlendMode: "screen"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 39.625,
    height: 39.625,
    x: 19.188,
    y: 16.188,
    stroke: "#fff",
    strokeOpacity: 0.1,
    strokeWidth: 0.375,
    rx: 10.313
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    width: 61.188,
    height: 61.188,
    x: 0.406,
    y: 16.055
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#downloads_svg__h)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#downloads_svg__i)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#downloads_svg__j)",
    fillOpacity: 0.2,
    d: "M11 40.8c0-5.88 0-8.82 1.144-11.067a10.5 10.5 0 0 1 4.59-4.589C18.978 24 21.918 24 27.8 24h6.4c5.88 0 8.82 0 11.067 1.144a10.5 10.5 0 0 1 4.589 4.59C51 31.978 51 34.918 51 40.8v6.4c0 5.88 0 8.82-1.144 11.067a10.5 10.5 0 0 1-4.59 4.589C43.022 64 40.082 64 34.2 64h-6.4c-5.88 0-8.82 0-11.067-1.144a10.5 10.5 0 0 1-4.589-4.59C11 56.022 11 53.082 11 47.2z",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#downloads_svg__k)",
    d: "M11 40.8c0-5.88 0-8.82 1.144-11.067a10.5 10.5 0 0 1 4.59-4.589C18.978 24 21.918 24 27.8 24h6.4c5.88 0 8.82 0 11.067 1.144a10.5 10.5 0 0 1 4.589 4.59C51 31.978 51 34.918 51 40.8v6.4c0 5.88 0 8.82-1.144 11.067a10.5 10.5 0 0 1-4.59 4.589C43.022 64 40.082 64 34.2 64h-6.4c-5.88 0-8.82 0-11.067-1.144a10.5 10.5 0 0 1-4.589-4.59C11 56.022 11 53.082 11 47.2z",
    shapeRendering: "crispEdges",
    style: {
      mixBlendMode: "screen"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    strokeWidth: 0.375,
    d: "M27.8 24.188h6.4c2.943 0 5.14 0 6.881.142 1.74.142 3.008.425 4.1.982a10.3 10.3 0 0 1 4.508 4.506c.556 1.092.839 2.362.98 4.1.143 1.742.144 3.939.144 6.882v6.4c0 2.943 0 5.14-.143 6.881-.142 1.74-.425 3.008-.982 4.1a10.3 10.3 0 0 1-4.506 4.508c-1.093.556-2.362.839-4.1.98-1.742.143-3.939.144-6.882.144h-6.4c-2.943 0-5.14 0-6.881-.143-1.74-.142-3.009-.425-4.1-.982a10.3 10.3 0 0 1-4.507-4.506c-.557-1.093-.84-2.362-.982-4.1-.142-1.742-.143-3.939-.143-6.882v-6.4c0-2.943 0-5.14.143-6.881.142-1.74.425-3.008.982-4.1a10.3 10.3 0 0 1 4.506-4.507c1.092-.557 2.362-.84 4.1-.982 1.742-.142 3.939-.142 6.882-.142Z",
    shapeRendering: "crispEdges"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#downloads_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M38 50.75H24m11.667-7.5L31 47.75m0 0-4.667-4.5M31 47.75v-10.5",
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "downloads_svg__b",
    width: 61.188,
    height: 61.188,
    x: 16.406,
    y: 0.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_4405"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_4405",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "downloads_svg__e",
    width: 61.188,
    height: 61.188,
    x: 8.406,
    y: 8.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_4405"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_4405",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "downloads_svg__i",
    width: 61.188,
    height: 61.188,
    x: 0.406,
    y: 16.055,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_4405"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_4405",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "downloads_svg__l",
    width: 18,
    height: 17.5,
    x: 22,
    y: 36.25,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.980392 0 0 0 0 0.505882 0 0 0 0 0.396078 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4772_4405"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.929412 0 0 0 0 0.380392 0 0 0 0 0.431373 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_4772_4405",
    result: "effect2_dropShadow_4772_4405"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_4772_4405",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "downloads_svg__c",
    x1: 48.25,
    x2: 48.25,
    y1: 8.588,
    y2: 74.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "downloads_svg__f",
    x1: 39,
    x2: 39,
    y1: 33.75,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "downloads_svg__j",
    x1: 31,
    x2: 31,
    y1: 41.75,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "downloads_svg__a",
    transform: "translate(-16.406 -.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 24.8c0-5.88 0-8.82 1.144-11.067a10.5 10.5 0 0 1 4.59-4.589C34.978 8 37.918 8 43.8 8h6.4c5.88 0 8.82 0 11.067 1.144a10.5 10.5 0 0 1 4.589 4.59C67 15.978 67 18.918 67 24.8v6.4c0 5.88 0 8.82-1.144 11.067a10.5 10.5 0 0 1-4.59 4.589C59.022 48 56.082 48 50.2 48h-6.4c-5.88 0-8.82 0-11.067-1.144a10.5 10.5 0 0 1-4.589-4.59C27 40.022 27 37.082 27 31.2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "downloads_svg__d",
    transform: "translate(-8.406 -8.055)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 19,
    y: 16,
    rx: 10.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "downloads_svg__h",
    transform: "translate(-.406 -16.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 40.8c0-5.88 0-8.82 1.144-11.067a10.5 10.5 0 0 1 4.59-4.589C18.978 24 21.918 24 27.8 24h6.4c5.88 0 8.82 0 11.067 1.144a10.5 10.5 0 0 1 4.589 4.59C51 31.978 51 34.918 51 40.8v6.4c0 5.88 0 8.82-1.144 11.067a10.5 10.5 0 0 1-4.59 4.589C43.022 64 40.082 64 34.2 64h-6.4c-5.88 0-8.82 0-11.067-1.144a10.5 10.5 0 0 1-4.589-4.59C11 56.022 11 53.082 11 47.2z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "downloads_svg__g",
    width: 1.6,
    height: 1.6,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#downloads_svg__m",
    transform: "scale(.00156)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "downloads_svg__k",
    width: 1.6,
    height: 1.6,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#downloads_svg__m",
    transform: "scale(.00156)"
  })))));
};
export default SvgDownloads;